import React from 'react';
import { CheckIcon, CreditCardIcon, EyeIcon, FlameIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { HERO_IMAGE, offerIncludes } from '../data/content';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
const trustBadges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-4 bg-cream-200 px-6 py-14 sm:py-16" aria-labelledby="oferta-titulo" data-id="element-116" data-mp="mgwjr9c9vuf2">
      <div className="mx-auto max-w-2xl" data-id="element-117" data-mp="wcr88l36gjpr">
        <SectionHeading id="oferta-titulo" title={<>
              Kit Instrumentación Industrial <Accent data-id="element-119" data-mp="2t6b5eco71pjf">Completo</Accent>
            </>} data-id="element-118" data-mp="wbok2kx8ovdj" />

        <div className="relative mx-auto mt-4 w-full max-w-md" data-id="element-120" data-mp="2y4couypj7qvf">
          <img src={HERO_IMAGE} alt="Contenido completo del Kit Instrumentación Industrial: 6 volúmenes y 5 bonos" width={1000} height={1000} loading="lazy" decoding="async" className="h-auto w-full" data-id="element-121" data-mp="2y4w5mc3g497v" />
          <span className="absolute -right-1 top-2 flex h-24 w-24 flex-col items-center justify-center text-center font-display font-bold leading-none text-white sm:h-28 sm:w-28" style={{
          backgroundColor: '#C86A1A',
          clipPath: 'polygon(50% 0%, 61% 12%, 78% 6%, 82% 24%, 98% 30%, 90% 46%, 100% 60%, 84% 68%, 86% 86%, 68% 84%, 58% 98%, 44% 88%, 28% 96%, 24% 78%, 6% 74%, 12% 58%, 0% 44%, 14% 34%, 8% 16%, 26% 18%, 34% 2%)'
        }} data-id="element-122" data-mp="xv8na5aefbr7">
            <span className="text-2xl sm:text-3xl" data-id="element-123" data-mp="1cl6ih56qx1pw">80%</span>
            <span className="mt-1 text-[0.6rem] uppercase tracking-widest" data-id="element-124" data-mp="1cnsoh0dzn960">OFF</span>
          </span>
        </div>

        <div className="mt-4 rounded-3xl border border-cream-100/10 bg-forest-800 px-6 py-8 text-center shadow-lift sm:px-10" data-id="element-125" data-mp="16j7qlm8uv8e">
          <p className="text-sm text-cream-100/60" data-id="element-126" data-mp="3scknh7h5md0d">
            Precio normal: <span className="line-through" data-id="element-127" data-mp="3sf6qqux0i6cs">$97 USD</span>
          </p>

          <span className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#E9A83B]/35 bg-[#E9A83B]/12 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.14em] text-[#F2C784]" data-id="element-128" data-mp="3tusqalixpvuq">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-129" data-mp="3kt1lrk04rv2g" />
            Precio de lanzamiento
          </span>

          <p className="mt-5 text-sm text-cream-100/60" data-id="element-130" data-mp="3owr8s515q4ld">Precio de lanzamiento:</p>
          <p className="mt-1 font-display text-5xl font-bold text-[#F2C784] sm:text-6xl" data-id="element-131" data-mp="3b270oiymf1il">$19 USD</p>
          <p className="mt-2 text-xs text-cream-100/55" style={{
          color: "#BE8100"
        }} data-id="element-132" data-mp="3fvjcfsi7bdtx">
            Se abona en tu moneda local
          </p>

          

          <CtaButton className="mt-6" variant="gold" fullWidth href={CHECKOUT_URL} label="Sí, Quiero Acceder Ahora" source="oferta" data-id="element-133" data-mp="363vlrttgy0ti" />

          <ul className="mx-auto mt-6 grid max-w-xs grid-cols-2 gap-y-2 text-xs text-cream-100/70" data-id="element-134" data-mp="2s55r0ku4gd8b">
            {trustBadges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center justify-center gap-1.5" data-id="element-135" data-mp="2dizzb6vt3828">
                <Icon className="h-3.5 w-3.5 text-[#E9A83B]/75" aria-hidden="true" data-id="element-136" data-mp="28jnf6twbkf3c" />
                {label}
              </li>)}
          </ul>

          <ul className="mt-7 grid gap-1.5 border-t border-cream-100/12 pt-6 text-left" data-id="element-137" data-mp="2mjy965sxe9sq">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-2 text-xs text-cream-100/80" data-id="element-138" data-mp="2ijec128cr66l">
                <CheckIcon className="h-3 w-3 shrink-0 text-[#E9A83B]/80" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="2weq411v4iijt" />
                <span className="min-w-0 flex-1 truncate" data-id="element-140" data-mp="2rfvl7zx5otzp">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-6 max-w-2xl rounded-2xl bg-cream-100/80 p-6 text-center" data-id="element-141" data-mp="317rpjspu5gcd">
          <h3 className="font-display text-xl font-semibold text-forest-800" data-id="element-142" data-mp="3f713smuhe0dp">Por qué hoy es el momento</h3>
          <p className="mt-3 text-sm leading-relaxed text-forest-700/75" data-id="element-143" data-mp="3a8hce6x4bwdy">
            Hoy recibís los 6 volúmenes técnicos (360 páginas) + los 5 bonos de implementación (150 páginas) a
            precio de lanzamiento. Después de esta ventana, el precio sube a $97 USD.
          </p>
          <p className="mt-3 text-sm font-semibold text-ember-600" data-id="element-144" data-mp="1i8towvx1lwgp">
            71% de los cupos ya se tomaron. Solo quedan 29 accesos al precio de lanzamiento.
          </p>
        </div>
      </div>
    </section>;
}